import img1 from "../../assets/images/user.png";
import { authService } from "../../api/auth.service";

function SideBar({ current, onSelect }) {
  const menuItems = [
    { key: "dashboard", label: "Dashboard", icon: "bx bxs-dashboard" },
    { key: "user", label: "Users", icon: "bx bxs-group" },
    { key: "courses", label: "Courses", icon: "bx bxs-book" },
  ];

  return (
    <div className="bg-white shadow-lg flex flex-col p-4 px-10 min-h-screen justify-between">
      <div>
        <div
        className="flex items-center gap-3 px-3 py-5 border-b border-gray-200 cursor-pointer"
        onClick={() => onSelect("dashboard")}
      >
        <img src={img1} alt="Admin Logo" className="w-10 h-10 rounded-full" />
        <span className="text-lg font-semibold text-[#1d7270]">LMS Admin</span>
      </div>
      <ul className="flex flex-col mt-6">
        {menuItems.map((item) => (
          <li key={item.key}>
            <button
              onClick={() => onSelect(item.key)}
              className={`w-full flex items-center gap-3 p-3 transition-colors rounded-lg mx-3 mb-3 text-left ${
                current === item.key
                  ? "bg-[#1d7270] text-white shadow-md"
                  : "text-gray-700 hover:bg-gray-100"
              }`}
            >
              <i className={`${item.icon} text-lg`} />
              <span className="font-medium">{item.label}</span>
            </button>
          </li>
        ))}
      </ul>
      </div>
      <div className="mb-4">
        <button
          onClick={() => authService.logout()}
          className="w-full flex items-center gap-3 p-3 transition-colors rounded-lg mx-3 text-left text-red-600 hover:bg-red-50 hover:text-red-700"
        >
          <i className="bx bx-log-out text-lg" />
          <span className="font-medium">Sign Out</span>
        </button>
      </div>
    </div>
  );
}

export default SideBar;
